module.exports = __webpack_public_path__ + "img/IMG_2443.5a609993.jpg";